class MarketingBannerCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.marketing-banner-carousel__slide')];
    this.dots = [...this.querySelectorAll('.marketing-banner-carousel__dot')];
    this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.interval = Number(this.dataset.interval) || 6000;

    if (this.slides.length < 2) return;

    this.querySelector('.marketing-banner-carousel__arrow--previous')?.addEventListener('click', () => this.goTo(this.current - 1));
    this.querySelector('.marketing-banner-carousel__arrow--next')?.addEventListener('click', () => this.goTo(this.current + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.goTo))));
    this.addEventListener('focusin', (event) => {
      if (event.target.matches(':focus-visible')) this.stop();
    });
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.start();
    });
    this.start();
  }

  goTo(index) {
    const next = (index + this.slides.length) % this.slides.length;
    this.slides[this.current].classList.remove('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'true');
    this.slides[this.current].querySelector('a')?.setAttribute('tabindex', '-1');
    this.dots[this.current]?.classList.remove('is-active');
    this.dots[this.current]?.setAttribute('aria-current', 'false');

    this.current = next;
    this.slides[this.current].classList.add('is-active');
    this.slides[this.current].setAttribute('aria-hidden', 'false');
    this.slides[this.current].querySelector('a')?.removeAttribute('tabindex');
    this.dots[this.current]?.classList.add('is-active');
    this.dots[this.current]?.setAttribute('aria-current', 'true');
  }

  start() {
    if (this.timer || this.slides.length < 2) return;
    this.timer = window.setInterval(() => this.goTo(this.current + 1), this.interval);
  }

  stop() {
    window.clearInterval(this.timer);
    this.timer = null;
  }

  disconnectedCallback() {
    this.stop();
  }
}

if (!customElements.get('marketing-banner-carousel')) {
  customElements.define('marketing-banner-carousel', MarketingBannerCarousel);
}
